import { ReactElement, useEffect, useState } from "react";
import { InitialProps } from "../../interfaces/props/InitialProps";
import { useGetPermissionQuery } from "../../store/api/permission.api";
import { useAppDispatch } from "../../store/reduxHooks";
import { DATA_ALL } from "../../store/slice/authSliceLogin/authSliceLogin";
import { Building } from "./Building/Building";

import classes from "./LoadingPage.module.css";

export function LoadingPage(): ReactElement {
  const { isLoading, data, error } = useGetPermissionQuery(undefined, {});
  const initialValues: InitialProps = {
    building: <Building />,
  };
  const [match] = useState<keyof InitialProps>("building");
  const dispatch = useAppDispatch();

  function isInitialValueMatch() {
    if (initialValues.hasOwnProperty(match)) return initialValues[match];
    return <Building />;
  }

  useEffect(() => {
    if (!isLoading && !error) dispatch(DATA_ALL(data));
    if (error?.status) {
      localStorage.clear();
      window.location.replace("/login");
    }
  }, [dispatch, data, isLoading, error]);

  return (
    <div className={classes.row}>
      <div className={classes.wrapperPageLoading}>{isInitialValueMatch()}</div>
    </div>
  );
}
